<template>
    <div class="sa-tab-scheda">
        <div class="sa-tab-scheda-row-fill" header="" header-tag="header" footer-tag="footer" title="">
            <b-card class="sa-card" header="VALORI" header-tag="header" footer-tag="footer" title="" style="height: calc(100% - 0.5rem); overflow-y: auto; overflow-x: hidden">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
                        <label class="sa-label-data">Altezza(cm)</label>
                        <span class="sa-data">{{ esameObiettivo.altezza }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
                        <label class="sa-label-data">Peso(kg)</label>
                        <span class="sa-data">{{ esameObiettivo.peso }}</span>
                    </b-col>
                </b-row>
                <hr />
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                        <label class="sa-label-data">FVC (L/s)</label>
                        <span class="sa-data">{{ data.fvc }}</span>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                        <label class="sa-label-data">FEV1 (L)</label>
                        <span class="sa-data">{{ data.fev1 }}</span>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" lg="2" xl="2">
                        <label class="sa-label-data">FEV1/FVC% (%)</label>
                        <span class="sa-data">{{ data.fev1Fvc }}</span>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" lg="2" xl="2">
                        <label class="sa-label-data">PEF(L/s)</label>
                        <span class="sa-data">{{ data.pef }}</span>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" lg="2" xl="2">
                        <label class="sa-label-data">FEF-25-75% (L/s)</label>
                        <span class="sa-data">{{ data.fef2575 }}</span>
                    </b-col>
                </b-row>
                <hr />
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                        <label class="sa-label-data">MEF25% (L/s)</label>
                        <span class="sa-data">{{ data.mef25 }}</span>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                        <label class="sa-label-data">MEF50% (L/s)</label>
                        <span class="sa-data">{{ data.mef50 }}</span>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                        <label class="sa-label-data">MEF75% (L/s)</label>
                        <span class="sa-data">{{ data.mef75 }}</span>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                        <label class="sa-label-data">MVV(L/m)</label>
                        <span class="sa-data">{{ data.mvv }}</span>
                    </b-col>
                </b-row>
            </b-card>
        </div>
        <div>
            <b-card class="sa-card" header="VALORI NORMALI" header-tag="header" footer-tag="footer" title="" style="height: calc(100% - 0.5rem); overflow-y: auto; overflow-x: hidden">
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                        <label class="sa-label-data">FVC (L/s)</label>
                        <span class="sa-data">{{ data.fvcNormale }}</span>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                        <label class="sa-label-data">FEV1 (L)</label>
                        <span class="sa-data">{{ data.fev1Normale }}</span>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" lg="2" xl="2">
                        <label class="sa-label-data">FEV1/FVC% (%)</label>
                        <span class="sa-data">{{ data.fev1FvcNormale }}</span>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" lg="2" xl="2">
                        <label class="sa-label-data">PEF(L/s)</label>
                        <span class="sa-data">{{ data.pefNormale }}</span>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" lg="2" xl="2">
                        <label class="sa-label-data">FEF-25-75% (L/s)</label>
                        <span class="sa-data">{{ data.fef2575Normale }}</span>
                    </b-col>
                </b-row>
                <hr />
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                        <label class="sa-label-data">MEF25% (L/s)</label>
                        <span class="sa-data">{{ data.mef25Normale }}</span>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                        <label class="sa-label-data">MEF50% (L/s)</label>
                        <span class="sa-data">{{ data.mef50Normale }}</span>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                        <label class="sa-label-data">MEF75% (L/s)</label>
                        <span class="sa-data">{{ data.mef75Normale }}</span>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                        <label class="sa-label-data">MVV(L/m)</label>
                        <span class="sa-data">{{ data.mvvNormale }}</span>
                    </b-col>
                </b-row>
            </b-card>
        </div>
        <div>
            <b-card class="sa-card" header="CONCLUSIONI" header-tag="header" footer-tag="footer" title="" style="height: calc(100% - 0.5rem); overflow-y: auto; overflow-x: hidden">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Conclusioni</label>
                        <span class="sa-data">{{ data.conclusioni }}</span>
                    </b-col>
                </b-row>
            </b-card>
        </div>
        <div>
            <b-card class="sa-card" header="FIRMA" header-tag="header" footer-tag="footer" title="" style="height: calc(100% - 0.5rem); overflow-y: auto; overflow-x: hidden">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <span class="sa-data">{{ data.firma }}</span>
                    </b-col>
                </b-row>
            </b-card>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        data: {
            Type: Object,
            default: function () {
                return {
                    fvc: null,
                    fev1: null,
                    fev1Fvc: null,
                    pef: null,
                    fef2575: null,
                    mef25: null,
                    mef50: null,
                    mef75: null,
                    mvv: null,
                    conclusioni: "",
                    firma: "",
                    /*Valori Nomali */

                    fvcNormale: null,
                    fev1Normale: null,
                    fev1fvcNormale: null,
                    pefNormale: null,
                    fef2575Normale: null,
                    mef25Normale: null,
                    mef50Normale: null,
                    mef75Normale: null,
                    mvvNormale: null,
                };
            },
        },
        esameObiettivo: {
            Type: Object,
            default: function () {
                return {};
            },
        },
    },
};
</script>
